(function (win, $) {
    'use strict';
    var fp = (win.fp = typeof win.fp !== 'undefined' ? win.fp : {}),
        home = (fp.home = typeof fp.home !== 'undefined' ? fp.home : {});

    var lazyLoadSlideshow = function () {
        // Lazy load all slideshow images after the initial
        [].forEach.call(document.querySelectorAll('.cycle-slideshow img[data-src]'), function (img) {
            img.setAttribute('src', img.getAttribute('data-src'));
            img.setAttribute('srcset', img.getAttribute('data-srcset'));
            img.setAttribute('sizes', img.getAttribute('data-sizes'));
            img.onload = function () {
                img.removeAttribute('data-src');
                img.removeAttribute('data-srcset');
                img.removeAttribute('data-sizes');
            };
        });
    };

    fp.home = (function () {
        return {
            init: function () {
                var initialLoad = true;

                $('.homepage-link').addClass('selected');

                // =========================================
                // Carousel controls
                // =========================================
                var carouselWrapper = $('.slideshow');
                var carouselTarget = $('.cycle-slideshow');
                var ariaLiveRegion = $('#control-announcements');
                $(carouselTarget).cycle();
                lazyLoadSlideshow();

                $(carouselWrapper).on("mouseenter focusin", function () {
                    if (!$(carouselTarget).hasClass('hard-pause')) {
                        $(carouselTarget).cycle('pause');
                    };
                });

                $(carouselWrapper).on("mouseleave focusout", function () {
                    if (!$(carouselTarget).hasClass('hard-pause')) {
                        $(carouselTarget).cycle('resume');
                    };
                });

                $('#cycle-pause-play').click(function () {
                    if ($(carouselTarget).hasClass('hard-pause')) {
                        $(carouselTarget).removeClass('hard-pause').cycle('resume');
                        $(this).text('Pause').attr('aria-label', 'Pause Carousel');
                        $(ariaLiveRegion).text('Carousel is playing.');
                    } else {
                        $(carouselTarget).addClass('hard-pause').cycle('pause');
                        $(this).text('Play').attr('aria-label', 'Play Carousel');
                        $(ariaLiveRegion).text('Carousel is paused.');
                    }
                });

                $('#cycle-back').click(function () {
                    $(ariaLiveRegion).text('Reading previous slide.');
                });

                $('#cycle-next').click(function () {
                    $(ariaLiveRegion).text('Reading next slide.');
                });

                // =========================================
                // Execute on initial load
                // =========================================

                if (initialLoad === true) {
                    $('body').delay(1000).removeClass('fade-home-contents');
                    initialLoad = false;
                }

                // =========================================
                // Detect scroll
                // =========================================

                $(window).scroll(function () {
                    var height = $(window).scrollTop();

                    if (height > 50) {
                        $('body').addClass("scrolled-down");
                    } else {
                        $('body').removeClass("scrolled-down");
                    }
                });


                // =========================================
                // Adjust hero
                // =========================================

                function adjustHero() {
                    var headerHeight = parseInt($('#main-header').outerHeight(), 10);
                    var pageMarginTop = parseInt($('.modern-browser-wrapper').css('margin-top'), 10);
                    var adjustment = (headerHeight + pageMarginTop + 5) * -1; // Add 5 to assure proper bleed
                    $('#hero').css('margin-top', adjustment);

                    //console.log("HEADER HEIGHT: " + headerHeight);
                    //console.log("MARGIN TOP: " + pageMarginTop);
                    //console.log("TOTAL ADJUSTMENT: " + adjustment);
                }

                // =========================================
                // BEGIN - bootstrap breakpoints
                // =========================================

                // Executes only in XS breakpoint
                //if (viewport.is('xs')) {

                //    // ...

                //}

                // Executes in SM, MD and LG breakpoints
                if (ResponsiveBootstrapToolkit.is('>=sm')) {
                    setTimeout(adjustHero, 250)
                }

                //if (ResponsiveBootstrapToolkit.is('>=md')) {

                //}

                // Executes in XS and SM breakpoints
                //if (viewport.is('<md')) {

                //    // ...

                //}

                // Execute code each time window size changes
                $(window).resize(
                    ResponsiveBootstrapToolkit.changed(function () {
                        if (ResponsiveBootstrapToolkit.is('>=sm')) {
                            setTimeout(adjustHero, 250)
                        }

                        if (ResponsiveBootstrapToolkit.is('<sm')) {
                            $('#hero').removeAttr('style');
                        }
                    })
                );
            }
        };
    })();
})(window, $);
